<div class="provider-list-page">
  <header>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-tab-group
          class="benefits-tabs"
          (selectedIndexChange)="onBenefitTabIndexChange($event)"
          [(selectedIndex)]="selectedBenefitTabIndex"
        >
          <mat-tab
            class="benefit-tab"
            [label]="benefit"
            *ngFor="let benefit of disciplineSearchParam.benefits"
          >
            <ng-template mat-tab-label>
              <mat-icon>folder</mat-icon>{{ benefit }}
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </mat-card-header>

      <mat-card-content>
        <div class="search-grid-container">
          <mat-form-field class="mat-form-field" appearance="outline">
            <mat-label>Province</mat-label>
            <mat-select
              (click)="onUserInteractChange()"
              [(value)]="selectedProvince"
              (selectionChange)="onProvinceSelected($event.value)"
            >
              <mat-option
                *ngFor="let province of filteredProvinces"
                [value]="province"
                >{{ province }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field" appearance="outline">
            <mat-label>Profession</mat-label>
            <mat-select
              (click)="onUserInteractChange()"
              [(value)]="selectedProfession"
              (selectionChange)="onProfessionSelected($event.value)"
              [disabled]="!hasMinimumSearchQueryParams"
            >
              <mat-option [value]="null">(All)</mat-option>
              <mat-option
                *ngFor="let profession of filteredProfessions"
                [value]="profession"
              >
                {{ profession }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            class="mat-form-field provider-name"
          >
            <mat-label>Name</mat-label>
            <input
              matInput
              [(ngModel)]="selectedName"
              (keydown.enter)="searchPaginatedDisciplines(false, true)"
              [disabled]="!hasMinimumSearchQueryParams"
            />
            <button
              *ngIf="selectedName"
              class="clear-name-icon-button"
              mat-icon-button
              matSuffix
              aria-label="Clear"
              (click)="clearName()"
            >
              <mat-icon class="small-icon">close</mat-icon>
            </button>
          </mat-form-field>
          <!-- <div class="show-concerns-toggle">
            <p>Concerns</p>
            <mat-slide-toggle
              [(ngModel)]="showConcernsOnly"
              [disabled]="!hasMinimumSearchQueryParams"
              [attr.aria-label]="
                showConcernsOnly ? 'search concerns only' : 'search all types'
              "
            >
              <span class="accessibility-aria-label-hidden">Concerns</span>
            </mat-slide-toggle>
          </div> -->
          <mat-card-actions class="search-actions">
            <button
              mat-button
              class="search-button"
              (click)="searchPaginatedDisciplines(true, true)"
              [disabled]="!hasMinimumSearchQueryParams"
            >
              Search
            </button>
            <button mat-button class="underlined-button" (click)="clear()">
              Clear search
            </button>
          </mat-card-actions>
        </div>
        <div class="paginator-container">
          <p><strong>Results:</strong></p>
          <mat-paginator
            #paginator
            [pageSizeOptions]="[20, 50, 100]"
            aria-label="Select page of disciplines"
            (page)="searchPaginatedDisciplines(false, true)"
            [disabled]="
              !hasMinimumSearchQueryParams || this.paginator.length == 0
            "
          ></mat-paginator>
        </div>
      </mat-card-content>
    </mat-card>
  </header>
  <main>
    <section
      class="results-list"
      [ngClass]="{
        expanded: !selectedDiscipline
      }"
    >
      <mat-form-field
        class="filter-field"
        appearance="outline"
        *ngIf="matDataSource.data.length > 0"
      >
        <input
          #input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Filter the results"
        />
      </mat-form-field>

      <div class="table-container">
        <!-- No Results -->
        <h2 class="message" *ngIf="matDataSource.data.length == 0 && !loading">
          {{ resultsMessage }}
        </h2>

        <!-- Results -->
        <table
          *ngIf="matDataSource.data.length > 0"
          mat-table
          [dataSource]="matDataSource"
          matSort
          class="results-table"
          tabindex="0"
          (keydown)="onKeydown($event)"
        >
          <ng-container matColumnDef="results">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Results list
            </th>
            <td
              mat-cell
              *matCellDef="let discipline"
              [ngClass]="{
                'selected-row-indicator':
                  discipline.id === selectedDiscipline?.id
              }"
            >
              <div class="details-row-box">
                <div
                  class="box"
                  [ngClass]="{
                    'extended-box': selectedDiscipline
                  }"
                >
                  <p
                    *ngIf="discipline?.name"
                    [ngClass]="{
                      'selected-name': discipline?.id === selectedDiscipline?.id
                    }"
                  >
                    <strong>
                      {{
                        discipline.name ||
                          discipline?.provider?.name ||
                          discipline?.professional?.name
                      }}
                    </strong>
                  </p>
                </div>

                <div class="box" *ngIf="!selectedDiscipline">
                  <div *ngIf="discipline?.date">
                    <p>
                      Date:
                      {{ discipline?.date | date : dateFormat }}
                    </p>
                  </div>
                </div>

                <div class="box" *ngIf="!selectedDiscipline">
                  <div *ngIf="discipline">
                    <p
                      class="truncated-text"
                      *ngIf="
                        discipline.professional?.status ||
                        discipline.provider?.status
                      "
                    >
                      Status:
                      {{
                        discipline.professional?.status ||
                          discipline.provider?.status
                      }}
                    </p>
                  </div>
                  <div>
                    <p *ngIf="discipline?.professional?.registrationNumber">
                      Registration number:
                      {{ discipline?.professional.registrationNumber }}
                    </p>
                    <p *ngIf="discipline?.provider?.accreditationNumber">
                      Accreditor:
                      {{ discipline?.provider?.accreditationNumber }}
                    </p>
                  </div>
                </div>

                <div class="box" *ngIf="!selectedDiscipline">
                  <p>Type: {{ discipline.type }}</p>
                </div>

                <div class="box tr" *ngIf="selectedDiscipline">
                  <p>Type: {{ discipline.type }}</p>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="
              let discipline;
              columns: displayedColumns;
              let i = index
            "
            (click)="openDetails(discipline, getActualIndex(i))"
            [id]="'row-' + discipline.id"
          ></tr>
        </table>
      </div>
    </section>

    <mat-card
      appearance="outlined"
      class="details-container"
      *ngIf="selectedDiscipline"
    >
      <div class="details-title">
        <div class="title">
          <h3>
            {{ selectedDiscipline?.name || selectedDiscipline?.provider?.name }}
            <span>
              <a
                *ngIf="formatUrl(selectedDiscipline?.link) as disciplineLink"
                [href]="disciplineLink"
                [matTooltip]="disciplineLink"
                target="_blank"
                class="link-with-icon"
                rel="noopener"
                aria-label="Opens in a new tab"
              >
                <mat-icon class="mat-icon-small">open_in_new</mat-icon>
              </a>
            </span>
          </h3>
        </div>
        <button mat-icon-button aria-label="Close" (click)="onCloseDetails()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-card-content class="details-card-content">
        <discipline-details-view
          [discipline]="selectedDiscipline"
          [province]="selectedProvince"
        ></discipline-details-view>
      </mat-card-content>
    </mat-card>
  </main>
</div>
